import {useToast} from "vue-toastification";
import { $axios, apiList } from '@/api'

const toast = useToast()

export default {
    state: () => ({
        openWindows: [],
        // attemptId => []
        attempts: {}
    }),

    mutations: {
        addWindow(state, windowId) {

            if (!state.openWindows.includes(windowId)) {
                state.openWindows.push(windowId)
                 localStorage.setItem('quiz_window', JSON.stringify({
                 windowId,
                 expiresAt: Date.now() + 60 * 60 * 1000
                }))
            }
        },
        removeWindow(state, windowId) {
            state.openWindows = state.openWindows.filter(id => id !== windowId)
            localStorage.removeItem('quiz_window')
        }
    },

    actions: {
        startAttempt(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.quiz.startAttempt.method,
                    params: {
                        quizid: payload,
                        wsfunction: apiList.quiz.startAttempt.moodle_method,
                    }
                }).then(resp => {
                    resolve(resp.data)
                })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        getAttemptReview(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.quiz.getAttemptReview.method,
                    params: {
                        wsfunction: apiList.quiz.getAttemptReview.moodle_method,
                        id: payload,
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => {
                        toast.error(err.message)
                        reject(err)
                    })
            })
        },
        viewQuiz(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.quiz.viewQuiz.method,
                    params: {
                        wsfunction: apiList.quiz.viewQuiz.moodle_method,
                        quizid: payload
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => {
                        toast.error(err.message)
                        reject(err)
                    })
            })
        },
        runCodeInSandbox(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.coderunner.runInSandbox.method,
                    params: {
                        wsfunction: apiList.coderunner.runInSandbox.moodle_method,
                        sourcecode: payload.sourcecode,
                        contextid: payload.contextid,
                        language: payload.language,
                        params: payload.params ? payload.params : '{"cputime":5,"runargs":[]}',
                        stdin: payload.stdin,
                        files: payload.files,
                    },
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        },
        checkCodeAnswer(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.quiz.checkCoderunnerAnswer.method,
                    params: {
                        wsfunction: apiList.quiz.checkCoderunnerAnswer.moodle_method,
                        attemptid: payload.id,
                        slot: payload.slot,
                        precheck: payload.precheck===true?1:0
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },

        getAttemptData(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.quiz.getAttemptData.method,
                    params: {
                        wsfunction: apiList.quiz.getAttemptData.moodle_method,
                        attemptid: payload.id,
                        page: payload.page
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },

        getAttemptDataJson(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.quiz.getAttemptDataJson.method,
                    params: {
                        wsfunction: apiList.quiz.getAttemptDataJson.moodle_method,
                        attemptid: payload.id,
                        page: payload.page
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        finishAttempt(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.quiz.processAttempt.method,
                    params: {
                        wsfunction: apiList.quiz.processAttempt.moodle_method,
                        attemptid: payload,
                        finishattempt: 1
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        processAttempt(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.quiz.processAttempt.method,
                    params: {
                        wsfunction: apiList.quiz.processAttempt.moodle_method,
                        attemptid: payload.id,
                    },
                    data: {
                        ...payload.data
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        saveAttempt(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.quiz.saveAttempt.method,
                    params: {
                        wsfunction: apiList.quiz.saveAttempt.moodle_method,
                        attemptid: payload.id,
                    },
                    data: {
                        ...payload.data
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getUserAttempts(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.quiz.getUserAttempts.method,
                    params: {
                        wsfunction: apiList.quiz.getUserAttempts.moodle_method,
                        quizid: payload,
                        status: 'all',
                    },
                    data: {
                        includepreviews: 1
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getAttemptSummary(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.quiz.getAttemptSummary.method,
                    params: {
                        wsfunction: apiList.quiz.getAttemptSummary.moodle_method,
                        attemptid: payload
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getAttemptAccessInf(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.quiz.getAttemptAccessInf.method,
                    params: {
                        wsfunction: apiList.quiz.getAttemptAccessInf.moodle_method,
                        quizid: payload,
                        attemptid: 0
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },

        getUserBestGrade(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.quiz.getUserBestGrade.method,
                    params: {
                        wsfunction: apiList.quiz.getUserBestGrade.moodle_method,
                        quizid: payload
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },

        getQuizAccessInformation(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.quiz.getQuizAccessInformation.method,
                    params: {
                        wsfunction: apiList.quiz.getQuizAccessInformation.moodle_method,
                        quizid: payload
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },

        safetyModeFail(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.quiz.safetyModeFail.method,
                    params: {
                        wsfunction: apiList.quiz.safetyModeFail.moodle_method,
                        objectId: payload,
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    })
                    .catch(err => reject(err))
            })
        },

        openWindow({ commit }, windowId) {
            commit('addWindow', windowId);
        },

        closeWindow({ commit }, windowId) {
            commit('removeWindow', windowId);
        },
    }
}
